import React from 'react';

const About = () => (
  <div className="w-full">
    <h2 className="text-xl font-bold mb-2">About</h2>
    <p className="text-justify">Rules Viewer</p>
  </div>
);

export default About;
